<script setup>
import { computed } from 'vue';

const props = defineProps({
  debug: {
    type: Object,
    default: null,
  },
});

const line = computed(() => {
  const debug = props.debug;
  if (!debug || typeof debug !== 'object') return '';

  const parts = [
    debug.reasoning_profile,
    debug.model,
    debug.input_tokens != null ? `in ${debug.input_tokens}` : null,
    debug.output_tokens != null ? `out ${debug.output_tokens}` : null,
    debug.prompt_cache_hit_tokens != null
      ? `cache ${debug.prompt_cache_hit_tokens}`
      : null,
  ].filter(part => part !== undefined && part !== null && part !== '');

  return parts.join(' · ');
});
</script>

<template>
  <p
    v-if="line"
    class="mx-4 mb-1 truncate text-[11px] leading-4 text-n-slate-10"
  >
    {{ line }}
  </p>
</template>
